import { render, staticRenderFns } from "./group-documents-menu.vue?vue&type=template&id=7bf1ddf4&%40click%3Aoutside=closeThisMenu&"
import script from "./group-documents-menu.vue?vue&type=script&lang=js&"
export * from "./group-documents-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports